export default "__VITE_ASSET__4aa11d39__"